import { Avatar, Box, Typography } from "@mui/material"
import { styled } from "@mui/system"
import AdminUser from "models/convention-api/v1/AdminUser"
import React from "react"
import { nameToInitials } from "utils/helpers"

interface AdminUserCardProps {
  adminUser: AdminUser
}

export const AdminUserCard = (props: AdminUserCardProps) => {
  const { adminUser } = props
  const name = `${adminUser.first_name} ${adminUser.last_name}`

  return (
    <_RootContainer>
      <_Avatar src={adminUser.avatar.thumb_url} children={nameToInitials(name)} />
      <_TextContainer>
        <_Name>{name}</_Name>
        <_Title>{adminUser.title}</_Title>
      </_TextContainer>
    </_RootContainer>
  )
}

const _RootContainer = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  padding: "12px 0",
}));

const _Avatar = styled(Avatar)(({ theme }) => ({
  width: 50,
  height: 50,
  backgroundColor: theme.palette.primary.main,
})) as typeof Avatar

const _TextContainer = styled(Box)({
  flexGrow: "1",
  marginLeft: "15px",
})

const _Name = Typography

const _Title = styled(Typography)(({ theme }) => ({
  fontStyle: "italic",
  color: theme.palette.gray.dark,
}))
